import { useMemo, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { loadSegmentSuccess, initSegmentIdentity } from '../store/globalSettings/globalSettings.actions';
import { getIsSegmentLoaded, getIsSegmentInit } from '../store/globalSettings/globalSettings.selectors';

export default () => {
  const dispatch = useDispatch();

  const handleLoadSegmentSuccess = useCallback(() => dispatch(loadSegmentSuccess()), [dispatch]);
  const handleSegmentInit = useCallback(() => dispatch(initSegmentIdentity()), [dispatch]);

  const isSegmentLoaded = useSelector(getIsSegmentLoaded);
  const isSegmentInit = useSelector(getIsSegmentInit);

  return useMemo(
    () => ({
      handleLoadSegmentSuccess,
      handleSegmentInit,
      isSegmentLoaded,
      isSegmentInit,
    }),
    [handleLoadSegmentSuccess, handleSegmentInit, isSegmentLoaded, isSegmentInit],
  );
};
